module Meevo.Components.Controls {
    "use strict";
    interface IMembershipPaymentAccountsScope extends angular.IScope {
        model: Model.PaymentAccount[],
        merchantTerminalId: string,
        merchantAccountId: string,
        merchantProviderId: number,
        directManualEntry: boolean,
        autoDeletePreviousPaymentAccount: boolean,
        addPaymentAccount(): void,
        deletePaymentAccount(index : number) : void,
        showHsaFsa: boolean,
        canEditExpirationDate: boolean
    }

    export class MembershipPaymentAccounts implements angular.IDirective {

        restrict = "E";
        templateUrl = "app/components/controls/paymentAccounts/membershipPaymentAccounts.template.html";
        scope = {
            model: "=ngModel",
            merchantTerminalId: "=",
            merchantAccountId: "=",
            merchantProviderId: "=",
            disabled: "=?ngDisabled",
            directManualEntry: "=?",
            autoDeletePreviousPaymentAccount: "=",
            elevationChallenge: '&?',
            showHsaFsa: '=?',
            showHsaFsaAfterAccountCreation: '=?',
            canEditExpirationDate: "=?",
            isHostedPageAutomaticallySwitch: "=?",
        };
        link = (scope: IMembershipPaymentAccountsScope, element: JQuery, attr: angular.IAttributes, ngModel) => {
            scope.addPaymentAccount = ()=> {
                scope.model.push({
                    paymentAccountType: Model.PaymentAccountTypeEnum.Card,
                    merchantAccountId: scope.merchantAccountId
                });
            }

            scope.deletePaymentAccount = (index) =>{
                scope.model.splice(index, 1);
            }
            scope.hostedPageIntent = Meevo.Model.HostedPageIntent.Recurring;
        }

        static factory(): angular.IDirectiveFactory {
            let directive = () => {
                return new MembershipPaymentAccounts();
            };

            return directive;
        }
    }

    angular.module("meevo.components.controls")
        .directive("meevoMembershipPaymentAccounts", MembershipPaymentAccounts.factory());
}